import React, { useEffect, useMemo, useState } from 'react'
import { Text } from '@leverege/ui-elements'
import { GlobalState } from '@leverege/ui-redux'
import { GroupDelegate, ItemDelegate } from '@leverege/molten-core'
import { Attributes } from '@leverege/ui-attributes'

export default {
  id : 'ps.attr.product.event.location.TableCellRenderer',
  objectType : 'product.event',
  attrName : 'product.event.location',
  renderer : data => <ProductEventSubtypeRenderer {...data} />
}

function ProductEventSubtypeRenderer( props ) {
  const { value, delegate } = props

  const [ pog, setPog ] = useState()
  const [ aisle, setAisle ] = useState()
  const segment = value?.segmentId ? ItemDelegate.getItem( value.segmentId ) : null

  const { pogDelegate, aisleDelegate } = useMemo( () => {
    const pd = delegate.parent()?.child( 'pogs' )
    const ad = delegate.parent()?.child( 'aisles' )

    return {
      pogDelegate : new GroupDelegate( {
        match : pd.match,
        relationship : pd.relationship,
        ttl : 30000,
        queryName : 'product.event.location.pog'
      } ),
      aisleDelegate : new GroupDelegate( {
        match : ad.match,
        relationship : ad.relationship,
        ttl : 30000,
        queryName : 'product.event.location.aisle'
      } )
    }
  }, [ delegate ] )

  useEffect( () => {
    const loadItem = async () => {
      if ( value ) {
        const pog = ItemDelegate.getItem( value.pogId )
  
        if ( !pog ) {
          GlobalState
            .dispatch( pogDelegate.item( value.pogId ).get() )
            .then( ( res ) => {
              setPog( res )
            } )
        } else {
          setPog( pog )
        }

        const aisle = ItemDelegate.getItem( value.aisleId )
            
        if ( !aisle ) {
          GlobalState
            .dispatch( aisleDelegate.item( value.aisleId ).get() )
            .then( ( res ) => {
              setAisle( res )
            } )
        } else {
          setAisle( aisle )
        }
      }
    }

    loadItem()
  }, [ value, aisleDelegate, pogDelegate ] )

  if ( !value ) {
    return '-'
  }

  const aisleName = `${aisle?.name} - ` || ''
  const pogName = Attributes.get( 'pog.group', 'pog', pog ) || ''
  const segmentIndex = Attributes.get( 'segment.idx', 'segment', segment ) || ''

  return (
    <Text
      variant="columnValue">
      {aisleName}{pogName} {segmentIndex}.{value.level}
    </Text>
  )
}
